import { useTokenTime } from 'hooks/token';

const TokenTime = () => useTokenTime();

export default TokenTime;
